import { io } from 'socket.io-client'
import { API_BASE_URL } from '../constants/api.js'

let socket = null
let isSocketConnected = false
const statusListeners = new Set()

const getSocketBaseUrl = () => API_BASE_URL.replace(/\/api\/?$/, '')

const notifyStatusListeners = () => {
  statusListeners.forEach((listener) => listener(isSocketConnected))
}

const setSocketConnected = (connected) => {
  if (isSocketConnected === connected) return
  isSocketConnected = connected
  notifyStatusListeners()
}

export const connectMessageSocket = (token) => {
  if (!token) return null

  // One authenticated Socket.IO connection is shared by messages and notifications.
  // The backend puts this socket into the current user's private room.
  if (socket) {
    const currentToken = typeof socket.auth === 'object' ? socket.auth?.token : null

    if (currentToken !== token) {
      socket.disconnect()
      socket = null
      setSocketConnected(false)
    } else if (!socket.connected) {
      socket.connect()
      return socket
    } else {
      return socket
    }
  }

  socket = io(getSocketBaseUrl(), {
    auth: { token },
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    rememberUpgrade: true,
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 10000,
  })

  socket.on('connect', () => setSocketConnected(true))
  socket.on('disconnect', () => setSocketConnected(false))
  socket.on('connect_error', () => setSocketConnected(false))

  socket.connect()
  return socket
}

export const getMessageSocketConnectionStatus = () => isSocketConnected

export const subscribeToMessageSocketStatus = (listener) => {
  statusListeners.add(listener)
  listener(isSocketConnected)

  return () => {
    statusListeners.delete(listener)
  }
}

export const disconnectMessageSocket = () => {
  if (!socket) return
  setSocketConnected(false)
  socket.removeAllListeners()
  socket.disconnect()
  socket = null
}
